// extracted by mini-css-extract-plugin
export default {"timeCell":"TimeCell_timeCell__LlUx+","cell":"TimeCell_cell__lZHK9"};